module.exports = __webpack_public_path__ + "static/bioMed-1a4a47cfc3ade9bc95087a3b92911573.jpg";